'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var compositionApi = require('@vue/composition-api');
var dateFns = require('date-fns');
var dateFnsEnUs = _interopDefault(require('date-fns/locale/en-US'));
var lodash = require('lodash');
var ResizeObserverPonyfill = _interopDefault(require('resize-observer-polyfill'));
var uuid = require('uuid');

var now = new Date();
function useLocalization(locale, options) {
  var weekdayNames = dateFns.eachDayOfInterval({
    start: dateFns.startOfWeek(now),
    end: dateFns.endOfWeek(now)
  }).map(function (d) {
    return locale.value.localize.day(d.getDay());
  });
  var weekdaysShort = weekdayNames.map(function (name) {
    return name.substr(0, options.value.shortWeekdaysLength);
  });
  return {
    locale: locale,
    weekdayNames: weekdayNames,
    weekdaysShort: weekdaysShort
  };
}

function useCalendarItems(calendar) {
  var firstOfMonth = compositionApi.computed(function () {
    return new Date(calendar.value.year, calendar.value.month, 1, 0, 0, 0, 0);
  });
  var lastOfMonth = compositionApi.computed(function () {
    return dateFns.endOfMonth(firstOfMonth.value);
  });
  var currentMonthDates = compositionApi.computed(function () {
    return dateFns.eachDayOfInterval({
      start: firstOfMonth.value,
      end: lastOfMonth.value
    });
  });
  var prevMonthDates = compositionApi.computed(function () {
    return dateFns.eachDayOfInterval({
      start: dateFns.subMonths(firstOfMonth.value, 1),
      end: new Date(firstOfMonth.value.getFullYear(), firstOfMonth.value.getMonth(), 0)
    });
  });
  var nextMonthDates = compositionApi.computed(function () {
    return dateFns.eachDayOfInterval({
      start: dateFns.addMonths(firstOfMonth.value, 1),
      end: dateFns.addMonths(lastOfMonth.value, 1)
    });
  });
  var calendarItems = compositionApi.computed(function () {
    var items = [];
    var firstOfMonthDay = firstOfMonth.value.getDay();

    for (var i = 0; i < firstOfMonthDay; ++i) {
      var date = prevMonthDates.value[prevMonthDates.value.length - (firstOfMonthDay - i)];
      items.push({
        date: date,
        isCurrentMonth: false
      });
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = currentMonthDates.value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _date2 = _step.value;
        items.push({
          date: _date2,
          isCurrentMonth: true
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var remaining = 7 - items.length % 7;

    for (var _i = 0; _i < remaining; ++_i) {
      var _date = nextMonthDates.value[_i];
      items.push({
        date: _date,
        isCurrentMonth: false
      });
    }

    return items;
  });
  var calendarRows = compositionApi.computed(function () {
    var count = Math.ceil(calendarItems.value.length / 7);
    var rows = [];

    for (var i = 0; i < count; ++i) {
      var items = [];

      for (var c = i * 7; c < (i + 1) * 7; ++c) {
        items.push(calendarItems.value[c]);
      }

      rows.push({
        items: items
      });
    }

    return rows;
  });
  return {
    firstOfMonth: firstOfMonth,
    lastOfMonth: lastOfMonth,
    currentMonthDates: currentMonthDates,
    prevMonthDates: prevMonthDates,
    nextMonthDates: nextMonthDates,
    calendarItems: calendarItems,
    calendarRows: calendarRows
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function useCalendarItemStyle(items, context) {
  var pluginClasses = compositionApi.ref([]);
  var classes = compositionApi.computed(function () {
    return items.value.map(function (item, i) {
      var classes = ['AirbnbCalendarItem'];

      if (item.isCurrentMonth) {
        classes.push('is-current-month');
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = context.value.calendarItemPlugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var plugin = _step.value;

          if (plugin.classes) {
            classes.push.apply(classes, _toConsumableArray(plugin.classes.apply(plugin, [item, context.value])));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (pluginClasses.value[i] || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var name = _step2.value;
          classes.push(name);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return classes;
    });
  });

  var addClass = function addClass(item) {
    var index = items.value.indexOf(item);

    if (index === -1) {
      return;
    }

    pluginClasses.value[index] = pluginClasses.value[index] || [];

    for (var _len = arguments.length, classNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      classNames[_key - 1] = arguments[_key];
    }

    for (var _i = 0, _classNames = classNames; _i < _classNames.length; _i++) {
      var name = _classNames[_i];

      if (pluginClasses.value[index].indexOf(name) === -1) {
        pluginClasses.value[index].push(name);
      }
    }
  };

  var removeClass = function removeClass(item) {
    var index = items.value.indexOf(item);

    if (index === -1) {
      return;
    }

    pluginClasses.value[index] = pluginClasses.value[index] || [];

    for (var _len2 = arguments.length, classNames = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      classNames[_key2 - 1] = arguments[_key2];
    }

    for (var _i2 = 0, _classNames2 = classNames; _i2 < _classNames2.length; _i2++) {
      var name = _classNames2[_i2];
      var nameIndex = pluginClasses.value[index].indexOf(name);

      if (nameIndex === -1) {
        continue;
      }

      pluginClasses.value[index].splice(nameIndex, 1);
    }
  };

  var styles = compositionApi.computed(function () {
    return items.value.map(function (item, i) {
      var styles = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = context.value.calendarItemPlugins[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var plugin = _step3.value;

          if (plugin.styles) {
            styles = Object.assign({}, styles, {}, plugin.styles.apply(plugin, [item, classes.value[i] || [], context.value]));
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return styles;
    });
  });
  return {
    classes: classes,
    addClass: addClass,
    removeClass: removeClass,
    styles: styles
  };
}

var RenderCalendarItem = compositionApi.createComponent({
  props: {
    item: Object,
    renderFns: Array,
    classes: {},
    styles: {}
  },
  render: function render(h) {
    var p = this;
    var vnode = h('div', {
      class: p.classes,
      style: p.styles
    }, [h('span', {
      class: 'AirbnbCalendarItem__day'
    }, dateFns.format(p.item.date, 'd'))]);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = p.renderFns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var renderFn = _step.value;
        vnode = renderFn(h, vnode, {
          item: p.item,
          classes: p.classes
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return vnode;
  }
});

var script = compositionApi.createComponent({
  components: {
    RenderCalendarItem: RenderCalendarItem
  },
  props: {
    context: Object
  },
  setup: function setup(props, ctx) {
    var _useLocalization = useLocalization(compositionApi.computed(function () {
      return props.context.options.dateFnsLocale || dateFnsEnUs;
    }), compositionApi.computed(function () {
      return props.context.options;
    })),
        weekdaysShort = _useLocalization.weekdaysShort;

    var _useCalendarItems = useCalendarItems(compositionApi.computed(function () {
      return props.context.calendar;
    })),
        firstOfMonth = _useCalendarItems.firstOfMonth,
        calendarItems = _useCalendarItems.calendarItems,
        calendarRows = _useCalendarItems.calendarRows;

    var _useCalendarItemStyle = useCalendarItemStyle(calendarItems, compositionApi.computed(function () {
      return props.context;
    })),
        _addClass = _useCalendarItemStyle.addClass,
        _removeClass = _useCalendarItemStyle.removeClass,
        calendarItemStyles = _useCalendarItemStyle.styles,
        calendarItemClasses = _useCalendarItemStyle.classes;

    var isVisible = compositionApi.computed(function () {
      return props.context.visibleCalendars.indexOf(props.context.calendar) > -1;
    });
    var calendarItemRefs = compositionApi.ref(null);
    var calendarItemEventListeners = compositionApi.ref([]);
    compositionApi.onMounted(function () {
      if (!props.context.calendarItemPlugins.length) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var itemRef = _step.value;
          var el = itemRef.$el;
          var index = parseInt(el.dataset.num, 10);
          var item = calendarItems.value[index];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            var _loop2 = function _loop2() {
              var plugin = _step2.value;

              var _loop3 = function _loop3(event) {
                var eventKey = event;

                function listener(ev) {
                  plugin.on[eventKey](item, this, ev, {
                    addClass: function addClass() {
                      for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
                        classNames[_key] = arguments[_key];
                      }

                      return _addClass.apply(void 0, [item].concat(classNames));
                    },
                    removeClass: function removeClass() {
                      for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        classNames[_key2] = arguments[_key2];
                      }

                      return _removeClass.apply(void 0, [item].concat(classNames));
                    }
                  }, props.context);
                }

                el.addEventListener(eventKey, listener);
                calendarItemEventListeners.value.push({
                  el: el,
                  listener: listener,
                  event: eventKey
                });
              };

              for (var event in plugin.on || {}) {
                _loop3(event);
              }
            };

            for (var _iterator2 = props.context.calendarItemPlugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              _loop2();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        };

        for (var _iterator = (calendarItemRefs.value || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
    compositionApi.onBeforeUnmount(function () {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = calendarItemEventListeners.value[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _step3$value = _step3.value,
              el = _step3$value.el,
              event = _step3$value.event,
              listener = _step3$value.listener;
          el.removeEventListener(event, listener);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    });
    var calendarItemRenderFns = compositionApi.computed(function () {
      return props.context.calendarItemPlugins.map(function (plugin) {
        return plugin.calendarItemRenderFn;
      }).filter(function (renderFn) {
        return !!renderFn;
      });
    });
    return {
      firstOfMonth: firstOfMonth,
      formatDate: dateFns.format,
      weekdaysShort: weekdaysShort,
      calendarRows: calendarRows,
      calendarItemClasses: calendarItemClasses,
      calendarItemStyles: calendarItemStyles,
      isVisible: isVisible,
      calendarItemRefs: calendarItemRefs,
      calendarItemRenderFns: calendarItemRenderFns
    };
  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "AirbnbCalendarMonth",
    class: {
      'is-visible': _vm.isVisible
    }
  }, [_c('p', {
    staticClass: "AirbnbCalendarMonth__heading"
  }, [_vm._v("\n    " + _vm._s(_vm.formatDate(_vm.firstOfMonth, 'MMMM yyyy', {
    locale: _vm.context.options.dateFnsLocale
  })) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "AirbnbCalendarMonth__calendar",
    on: {
      "mouseleave": function mouseleave($event) {
        _vm.hoverItem = null;
      }
    }
  }, [_c('div', {
    staticClass: "AirbnbCalendarMonth__week"
  }, _vm._l(_vm.weekdaysShort, function (weekday) {
    return _c('div', {
      key: weekday,
      staticClass: "AirbnbCalendarMonth__cell is-heading",
      domProps: {
        "textContent": _vm._s(weekday)
      }
    });
  }), 0), _vm._v(" "), _vm._l(_vm.calendarRows, function (row, r) {
    return _c('div', {
      key: r,
      staticClass: "AirbnbCalendarMonth__week"
    }, _vm._l(row.items, function (item, c) {
      return _c('div', {
        key: r * 7 + c,
        staticClass: "AirbnbCalendarMonth__cell"
      }, [item.isCurrentMonth ? _c('RenderCalendarItem', {
        ref: "calendarItemRefs",
        refInFor: true,
        attrs: {
          "data-num": r * 7 + c,
          "item": item,
          "classes": _vm.calendarItemClasses[r * 7 + c],
          "styles": _vm.calendarItemStyles[r * 7 + c],
          "render-fns": _vm.calendarItemRenderFns
        }
      }) : _vm._e()], 1);
    }), 0);
  })], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var CalendarMonth = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function useCalendar(picker, options) {
  var pickerWidth = compositionApi.ref(0);
  var roHandler = lodash.debounce(function (entries) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var entry = _step.value;
        var target = entry.target;
        pickerWidth.value = target.clientWidth;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }, 250, {
    leading: false
  });
  var ResizeObserver = typeof window !== 'undefined' ? window.ResizeObserver || ResizeObserverPonyfill : ResizeObserverPonyfill;
  var ro = new ResizeObserver(roHandler);
  compositionApi.watch(picker, function (picker, oldPicker) {
    if (!oldPicker && picker) {
      ro.observe(picker);
    }
  });
  var now = new Date();
  var startCalendar = compositionApi.ref({
    year: (options.value.startMonth || now).getFullYear(),
    month: (options.value.startMonth || now).getMonth()
  });
  var maxVisibleCalendars = compositionApi.computed(function () {
    var calendars = [startCalendar.value];

    for (var i = 1; i < options.value.maxMonths; ++i) {
      var calendar = shiftCalendar(startCalendar.value, 0, i);

      if (options.value.lastMonth && (calendar.year > options.value.lastMonth.getFullYear() || calendar.year >= options.value.lastMonth.getFullYear() && calendar.month > options.value.lastMonth.getMonth())) {
        continue;
      }

      calendars[i] = calendar;
    }

    return calendars;
  });
  var visibleCalendars = compositionApi.computed(function () {
    var count = maxVisibleCalendars.value.length;
    count = 1 + Math.round((pickerWidth.value - 300) / 350);
    count = count <= 0 ? 1 : count;
    count = count > maxVisibleCalendars.value.length ? maxVisibleCalendars.value.length : count;
    return maxVisibleCalendars.value.slice(0, count);
  });
  var endCalendar = compositionApi.computed(function () {
    return visibleCalendars.value[visibleCalendars.value.length - 1];
  });
  var renderedCalendars = compositionApi.computed(function () {
    var calendars = visibleCalendars.value.slice();

    if (!calendars.length) {
      return calendars;
    }

    calendars.unshift(shiftCalendar(calendars[0], 0, -1));
    calendars.push(shiftCalendar(calendars[calendars.length - 1], 0, 1));
    return calendars;
  });

  var moduloFix = function moduloFix(num) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
    return (num % max + max) % max;
  };

  var shiftCalendar = function shiftCalendar(calendar, years, months) {
    calendar = {
      year: calendar.year,
      month: calendar.month
    };
    var year = calendar.year + years;
    var month = calendar.month + months;

    if (month < 0) {
      year--;
    } else if (month > 11) {
      year++;
    }

    calendar.year = year;
    calendar.month = moduloFix(month);
    return calendar;
  };

  var reachedMin = compositionApi.computed(function () {
    if (!options.value.firstMonth) {
      return false;
    }

    var prevCalendar = shiftCalendar(startCalendar.value, 0, -1);
    return isBeforeFirstMonth(prevCalendar.year, prevCalendar.month);
  });
  var reachedMax = compositionApi.computed(function () {
    if (!options.value.lastMonth) {
      return false;
    }

    var nextCalendar = shiftCalendar(visibleCalendars.value[visibleCalendars.value.length - 1], 0, 1);
    return isAfterLastMonth(nextCalendar.year, nextCalendar.month);
  });

  var isBeforeFirstMonth = function isBeforeFirstMonth(year, month) {
    if (!options.value.firstMonth) {
      return false;
    }

    return year < options.value.firstMonth.getFullYear() || year <= options.value.firstMonth.getFullYear() && month < options.value.firstMonth.getMonth();
  };

  var isAfterLastMonth = function isAfterLastMonth(year, month) {
    if (!options.value.lastMonth) {
      return false;
    }

    return year > options.value.lastMonth.getFullYear() || year >= options.value.lastMonth.getFullYear() && month > options.value.lastMonth.getMonth();
  };

  var shiftStartCalendar = function shiftStartCalendar(years, months) {
    var sumMonths = 12 * years + months;
    var calendar = shiftCalendar(startCalendar.value, years, months);

    if (isBeforeFirstMonth(calendar.year, calendar.month) || isAfterLastMonth(calendar.year, calendar.month)) {
      return;
    }

    if (sumMonths < 0 && reachedMin.value) {
      calendar.year = options.value.firstMonth.getFullYear();
      calendar.month = options.value.firstMonth.getMonth();
    }

    if (sumMonths > 0 && reachedMax.value) {
      var max = dateFns.subMonths(options.value.lastMonth, options.value.maxMonths - 1);
      calendar.year = max.getFullYear();
      calendar.month = max.getMonth();
    }

    startCalendar.value = calendar;
  };

  return {
    pickerWidth: pickerWidth,
    startCalendar: startCalendar,
    endCalendar: endCalendar,
    visibleCalendars: visibleCalendars,
    renderedCalendars: renderedCalendars,
    shiftCalendar: shiftCalendar,
    shiftStartCalendar: shiftStartCalendar,
    moduloFix: moduloFix,
    reachedMin: reachedMin,
    reachedMax: reachedMax
  };
}

function useCalendarStyle(renderedCalendars, visibleCalendars) {
  var monthStyles = compositionApi.computed(function () {
    var styles = {};

    for (var i = 0; i < renderedCalendars.value.length; ++i) {
      var widthPercentage = 100 / visibleCalendars.value.length;
      var style = {};

      if (visibleCalendars.value.indexOf(renderedCalendars.value[i]) > -1) {
        style.position = 'static';
      } else {
        style.position = 'absolute';
        style.width = widthPercentage + '%';
        style.left = -widthPercentage + i * widthPercentage + '%';
      }

      styles[renderedCalendars.value[i].year] = styles[renderedCalendars.value[i].year] || {};
      styles[renderedCalendars.value[i].year][renderedCalendars.value[i].month] = style;
    }

    return styles;
  });
  return {
    monthStyles: monthStyles
  };
}

function usePlugins() {
  var rootPlugins = compositionApi.ref([]);
  var calendarItemPlugins = compositionApi.ref([]);

  var installRootPlugin = function installRootPlugin(plugin) {
    return rootPlugins.value.push(plugin);
  };

  var installCalendarItemPlugin = function installCalendarItemPlugin(plugin) {
    return calendarItemPlugins.value.push(plugin);
  };

  var destroyFns = compositionApi.ref([]);

  var registerDestroyFn = function registerDestroyFn(fn) {
    return destroyFns.value.push(fn);
  };

  return {
    rootPlugins: rootPlugins,
    calendarItemPlugins: calendarItemPlugins,
    installRootPlugin: installRootPlugin,
    installCalendarItemPlugin: installCalendarItemPlugin,
    destroyFns: destroyFns,
    registerDestroyFn: registerDestroyFn
  };
}

var fixOptions = function fixOptions(options) {
  return Object.assign({
    maxMonths: 2,
    dateFnsLocale: dateFnsEnUs,
    shortWeekdaysLength: 3
  }, options);
};

var script$1 = compositionApi.createComponent({
  components: {
    CalendarMonth: CalendarMonth
  },
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props, _ref) {
    var $nextTick = _ref.root.$nextTick,
        slots = _ref.slots;
    var options = compositionApi.computed(function () {
      return fixOptions(props.options);
    });
    var calendarId = uuid.v4().substr(0, 8);
    var calendar = compositionApi.ref(null);

    var _useCalendar = useCalendar(calendar, options),
        startCalendar = _useCalendar.startCalendar,
        endCalendar = _useCalendar.endCalendar,
        visibleCalendars = _useCalendar.visibleCalendars,
        renderedCalendars = _useCalendar.renderedCalendars,
        shiftStartCalendar = _useCalendar.shiftStartCalendar,
        reachedMin = _useCalendar.reachedMin,
        reachedMax = _useCalendar.reachedMax,
        pickerWidth = _useCalendar.pickerWidth;

    var _useCalendarStyle = useCalendarStyle(renderedCalendars, visibleCalendars),
        monthStyles = _useCalendarStyle.monthStyles;

    var ready = compositionApi.ref(false);
    compositionApi.watch(pickerWidth, function (width, oldWidth) {
      if (!oldWidth && width) {
        ready.value = true;
      }
    });
    var rootContext = compositionApi.computed(function () {
      return {
        options: options.value,
        id: calendarId,
        el: calendar.value,
        visibleCalendars: visibleCalendars.value,
        calendarItemPlugins: calendarItemPlugins.value
      };
    });
    var calendarContexts = compositionApi.computed(function () {
      return renderedCalendars.value.map(function (calendar) {
        return Object.assign({}, rootContext.value, {
          calendar: calendar
        });
      });
    });

    var _usePlugins = usePlugins(),
        rootPlugins = _usePlugins.rootPlugins,
        calendarItemPlugins = _usePlugins.calendarItemPlugins,
        installRootPlugin = _usePlugins.installRootPlugin,
        installCalendarItemPlugin = _usePlugins.installCalendarItemPlugin,
        destroyFns = _usePlugins.destroyFns,
        registerDestroyFn = _usePlugins.registerDestroyFn;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (props.options.plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var plugin = _step.value;
        var install = plugin instanceof Function ? plugin : plugin.install;
        install.apply(plugin, [rootContext.value, {
          installRootPlugin: installRootPlugin,
          installCalendarItemPlugin: installCalendarItemPlugin
        }, registerDestroyFn]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    compositionApi.onMounted(function () {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop = function _loop() {
          var plugin = _step2.value;

          var _loop2 = function _loop2(event) {
            var eventKey = event;
            calendar.value.addEventListener(eventKey, function (ev) {
              plugin.on[eventKey](this, ev, rootContext.value);
            });
          };

          for (var event in plugin.on || {}) {
            _loop2(event);
          }
        };

        for (var _iterator2 = rootPlugins.value[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    });
    var watchers = props.options.watch || {};

    if (watchers.visibleCalendars) {
      compositionApi.onBeforeUnmount(compositionApi.watch(visibleCalendars, watchers.visibleCalendars.bind(options)));
    }

    if (watchers.renderedCalendars) {
      compositionApi.onBeforeUnmount(compositionApi.watch(renderedCalendars, watchers.renderedCalendars.bind(options)));
    }

    compositionApi.onBeforeUnmount(function () {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = destroyFns.value[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var fn = _step3.value;
          fn();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    });
    return {
      calendarContexts: calendarContexts,
      calendarId: calendarId,
      calendar: calendar,
      startCalendar: startCalendar,
      endCalendar: endCalendar,
      visibleCalendars: visibleCalendars,
      renderedCalendars: renderedCalendars,
      shiftStartCalendar: shiftStartCalendar,
      monthStyles: monthStyles,
      reachedMin: reachedMin,
      reachedMax: reachedMax,
      ready: ready
    };
  }
});

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "calendar",
    staticClass: "AirbnbCalendar",
    class: {
      'is-ready': _vm.ready
    },
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('transition', {
    attrs: {
      "name": "AirbnbCalendar__cursor-transition"
    }
  }, [!_vm.reachedMin ? _c('button', {
    staticClass: "AirbnbCalendar__cursor is-left",
    on: {
      "click": function click($event) {
        return _vm.shiftStartCalendar(0, -1);
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1000 1000"
    }
  }, [_c('path', {
    staticClass: "AirbnbCalendar__cursor-arrow",
    attrs: {
      "d": "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "AirbnbCalendar__cursor-transition"
    }
  }, [!_vm.reachedMax ? _c('button', {
    staticClass: "AirbnbCalendar__cursor is-right",
    on: {
      "click": function click($event) {
        return _vm.shiftStartCalendar(0, 1);
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1000 1000"
    }
  }, [_c('path', {
    staticClass: "AirbnbCalendar__cursor-arrow",
    attrs: {
      "d": "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('transition-group', {
    ref: "monthRefs",
    staticClass: "AirbnbCalendar__months",
    attrs: {
      "tag": "div",
      "name": _vm.ready ? 'AirbnbCalendar__month-transition' : ''
    }
  }, _vm._l(_vm.renderedCalendars, function (calendar, i) {
    return _c('div', {
      key: calendar.year + '-' + calendar.month,
      staticClass: "AirbnbCalendar__month-wrapper",
      style: _vm.monthStyles[calendar.year][calendar.month]
    }, [_c('CalendarMonth', {
      attrs: {
        "context": _vm.calendarContexts[i]
      }
    })], 1);
  }), 0)], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var AirbnbCalendarComponent = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var cssVar = function cssVar(name) {
  return '--dp-' + lodash.kebabCase(name);
};

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cssVar: cssVar
});

var index = {
  styles: styles
};

// @ts-ignore
var AirbnbCalendar = AirbnbCalendarComponent;

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // @ts-ignore
  if (install.installed) return; // @ts-ignore

  install.installed = true;
  Vue.component(options.name || 'AirbnbCalendar', AirbnbCalendar);
}

var AirbnbCalendarPlugin = {
  install: install
};
var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue; // @ts-ignore
} else if (typeof global !== 'undefined') {
  // @ts-ignore
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use({
    install: install
  });
}

exports.AirbnbCalendar = AirbnbCalendar;
exports.AirbnbCalendarPlugin = AirbnbCalendarPlugin;
exports.helpers = index;
